/**
 * Returns the normalized key for arrow key events
 * ie and edge return up, left, right, down instead prefixed with Arrow
 *
 * @param {SyntheticEvent} event to normalize
 * @return {String} event normalized key
 */
export function normalizeArrowKeys(event) {
  const { keyCode, key } = event

  if (keyCode >= 37 && keyCode <= 40 && key.indexOf('Arrow') !== 0) {
    return `Arrow${key}`
  }

  return key
}
